import { Toast, ToastContainer } from "react-bootstrap"
import timeService from "../../../services/time/timeService"
import { Link } from "react-router-dom"
import { currencyFormatter } from "../../../Helpers/Parsers/currencyFormatter"
import { BookingSourceIcon } from "../../../Components/Bookings/BookingEntry/BookingEntry"
import { bookingWithoutExtensions, getConfirmedExtensions } from "../../../Helpers/Bookings/bookingHelpers"
import UserNameText from "../../../Components/Users/UserNameText"

export default function BookingPreview(props: {
    booking: any,
    onClose: () => void
}) {
    const {
        booking,
        onClose = () => { }
    } = props

    if (!booking) {
        return null
    }
    const title = booking.type === 'extension' ? 'Extension Preview' : booking.type === 'payout' ? 'Payout Preview' : booking.type === 'booking' ? 'Booking Overview' : null
    const nights = timeService.calculateNights(booking.checkIn, booking.checkOut)
    const earnings = currencyFormatter(booking.earnings)
    const extensions = getConfirmedExtensions(booking)
    const originalBooking = bookingWithoutExtensions(booking)

    return (
        <div className="toast-fix">
            <ToastContainer>
                <Toast className="booking-preview-toast" show={booking && booking._id ? true : false} onClose={() => {
                    onClose()
                }}>
                    <Toast.Header>
                        <strong className="me-auto">
                            {booking.contactInfo?.firstName} {booking.contactInfo?.lastName}
                        </strong>
                        <small>{booking._id}</small>
                    </Toast.Header>
                    <Toast.Body>
                        {title && (
                            <>
                                <b className="pb-2">{title}</b><br/>
                            </>
                        )}
                        {booking.checkIn && booking.checkOut && (
                            <>
                                <b>{booking.type === 'extension' ? 'Extension Start' : 'Check In'}:</b> {timeService.createLuxonDate(booking.checkIn).toFormat('MM/dd/yyyy')}<br />
                                <b>{booking.type === 'extension' ? 'Extension End' : 'Check Out'}:</b> {timeService.createLuxonDate(booking.checkOut).toFormat('MM/dd/yyyy')}<br />
                            </>
                        )}
                        {booking.dateBooked && (
                            <>
                                <b>Date Booked:</b> {timeService.createLuxonDate(booking.dateBooked).toFormat('MM/dd/yyyy')}<br />
                            </>
                        )}
                        <b>Nights: </b> {nights}<br />
                        <b>Earnings: </b> {earnings} <small style={{color: "gray"}}>({currencyFormatter(booking.pricePerNight)}/night)</small><br />

                                <b>Source:</b> {booking.source}<BookingSourceIcon bookingInfo={booking} />
                                <br />
                                <b>Confirmation:</b> {booking.sourceConfirmation}<br />


                        {booking.type === 'extension' && (
                            <>
                                <b>Payment Source:</b> {booking.paymentSource}<br />
                                <b>Created By:</b> <UserNameText userId={booking.createdBy} /><br />
                            </>

                        )}

                        {booking.type === 'booking' && extensions.length > 0 && (
                            <div className="mt-1" key={booking._id}>
                                <small><b>Payout Breakdown:</b></small><br />
                                <div>
                                    <small>Original Booking: {timeService.createLuxonDate(originalBooking.checkIn).toFormat('MM/dd/yyyy')} - {timeService.createLuxonDate(originalBooking.checkOut).toFormat('MM/dd/yyyy')} ({currencyFormatter(originalBooking.earnings)})</small>
                                </div>
                                {extensions.map((extension: any, index: number) => (
                                    <div key={index}>
                                        <small>
                                            Extension {index + 1}: {timeService.createLuxonDate(extension.originalCheckOut).toFormat('MM/dd/yyyy')} - {timeService.createLuxonDate(extension.newCheckOut).toFormat('MM/dd/yyyy')} ({currencyFormatter(extension.payout)})<br />
                                            Payment Source: {extension.paymentSource}<br />
                                            Created By: <UserNameText userId={extension.createdBy} />
                                        </small>
                                    </div>
                                ))}
                            </div>
                        )}

                        <Link to={`/booking/${booking._id}`}>
                            View Booking
                        </Link>

                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </div>
    )
}